import { TextField } from "ots-components-library";
import type { Dispatch, SetStateAction } from "react";

import "./Search.scss";

export interface SearchProps {
  q: string;
  setQ: Dispatch<SetStateAction<string>>;
}

function Search({ q, setQ }: SearchProps) {
  return (
    <TextField
      value={q}
      onChange={(e) => setQ(e.target.value)}
      placeholder="Search by Name or Number"
      data-cy="searchBar"
      fullWidth
    />
  );
}

export default Search;
